module.exports = __webpack_public_path__ + "static/media/loader.027b4294.svg";